import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PostAttachments } from 'src/app/_models';
import { BaseComponent } from 'src/app/_base/base.component';
import { FilesService, SocialLearningService } from 'src/app/_services';
import { environment } from 'src/environments/environment';
import { MimeTypes } from 'src/app/_enums';

@Component({
  selector: 'app-facebook-downloader',
  templateUrl: './facebook-downloader.component.html',
  styleUrls: ['./facebook-downloader.component.scss']
})
export class FacebookDownloaderComponent extends BaseComponent implements OnInit {
  @Input()
  attachments: PostAttachments[] = [];
  @Input()
  isRemovable: boolean = false;
  @Output()
  attachmentsEmitter: EventEmitter<PostAttachments[]> = new EventEmitter<PostAttachments[]>();
  url = environment.apiUrl;
  constructor(private filesService: FilesService, private socialLearningService: SocialLearningService) {
    super();
  }

  ngOnInit() {}
  getImageUrl(attachment: PostAttachments): string {
    if (this.filesService.fileMimeTypeChecker(attachment.attachmentMimeType).mimeType === MimeTypes.Image)
      return this.getImage(attachment.attachmentFileName);
    else return this.filesService.fileMimeTypeChecker(attachment.attachmentMimeType).iconUrl;
  }
  downloadAttachment(attachment: PostAttachments): void {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = this.getImage(attachment.attachmentFileName);
    a.target = '_blank';
    a.download = attachment.attachmentFileName;
    a.click();
    document.body.removeChild(a);
  }
  removeAttachment(attachmentId: number): void {
    const callback = () => {
      this.socialLearningService.RemoveAttachment(attachmentId).subscribe(() => {
        const attachmentIndex = this.attachments.findIndex(item => item.attachmentId === attachmentId);
        if (attachmentId !== -1) this.attachments.splice(attachmentIndex, 1);
        this.attachmentsEmitter.emit(this.attachments);
      });
    };
    this.showConfirmYesNoMessage('Common.AreYouSureYouWantToDeleteThisAttachment?', 'Common.RemoveAttachment', callback);
  }
}
